const CLASSROOM_PROVIDER = {
  GOOGLE: 'google',
} as const;

type ClassroomProvider =
  (typeof CLASSROOM_PROVIDER)[keyof typeof CLASSROOM_PROVIDER];

const isImportedFromGoogle = (
  provider: string
): provider is ClassroomProvider => {
  return provider === CLASSROOM_PROVIDER.GOOGLE;
};

export { CLASSROOM_PROVIDER, isImportedFromGoogle };
export type { ClassroomProvider };
